import axios from "@/plugins/axios"
const token = localStorage.getItem("token")

export default {
    async getLegalCaseByInvoiceNumber(invoiceNumber){
        let legalCase = null;
        const response = await axios.postDataWithToken("/auth/get-legal-case-by-invoice_number",{invoiceNumber},token);
        if (response?.status === "success") {
            legalCase = response.case;
        }
        return legalCase;
        
    }
}